const EMPTY: Record<string, never> = {};
let currentTheme: 'light' | 'dark' | null =
  typeof window !== 'undefined' ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : null;

export function setCurrentTheme(theme: 'light' | 'dark' | null): void {
  currentTheme = theme;
}

export function getCurrentThemeFields(): { app_theme: 'light' | 'dark' } | Record<string, never> {
  return currentTheme ? { app_theme: currentTheme } : EMPTY;
}
